<template>
    <div class="photos">
        <el-carousel :interval="3000" type="card" height="400px" v-if="list && list.length" indicator-position="none">
            <el-carousel-item v-for="(item, index) in list" :key="index">
                <img :src="item" alt="">
            </el-carousel-item>
        </el-carousel>

        <el-carousel :interval="3000" type="card" height="400px" v-else indicator-position="none">
            <el-carousel-item v-for="(item, index) in 3" :key="index">
                <img src="../../assets/static/index/default.png"  alt="">
            </el-carousel-item>
        </el-carousel>


        <!-- <no-more v-else></no-more> -->
        <div class="desc" >
            <div class="desc_title">
                组织简介
            </div>
            <div class="desc_content" v-html="desc" ></div>
            <div v-if="!desc">暂无</div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            deptId () {
                return this.$route.params.id 
            }
        },
        data() {
            return {
                list: [],
                desc: "",
            }
        },
        mounted() {
            this.getPhotos()
        },
        methods: {
            // 获取组织相册
            async getPhotos () {
                let res = await this.$axios.post("/lencon/pc/dept/deptAlbum", { deptId: this.deptId })
                if ( res.data.code == 1 ) {
                    this.list = res.data.data.imgs
                    this.desc = res.data.data.deptBreifIntroduction
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.photos {
    width: 1200px;
    margin: 40px auto;
    background-color: #fff;
    min-height: 600px;
    padding: 40px;
    img {
        width: 560px;
        height: 336px;
    }
    .desc {
        .desc_title {
            font-size: 36px;
            font-weight: bold;
            text-align: left;
            margin: 20px 0;
        }
        margin: 40px 0;
    }
}
</style>